import React from 'react';
import UsageSummary from './UsageSummary/UsageSummary';

const UsageDashboardHeader = ({ isCustomerListFetching }) => {
  return <UsageSummary isCustomerListFetching={isCustomerListFetching}></UsageSummary>;
};
export default UsageDashboardHeader;
